/** Local calendar date as YYYY-MM-DD (not UTC). */
export const toLocalDateStr = (date: Date): string => {
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
};

export const monthDateRange = (year: number, monthIndex: number): { from: string; to: string } => {
  const last = new Date(year, monthIndex + 1, 0).getDate();
  const mm = `${monthIndex + 1}`.padStart(2, '0');
  return {
    from: `${year}-${mm}-01`,
    to: `${year}-${mm}-${String(last).padStart(2, '0')}`,
  };
};

export const getDaysInMonth = (month: number, year: number): number => {
  return new Date(year, month + 1, 0).getDate();
};

export const getDayOfWeek = (day: number, month: number, year: number): string => {
  const date = new Date(year, month, day);
  return date.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase().slice(0, 2);
};

export const getMonthName = (month: number, locale = 'en'): string => {
  return new Date(2026, month, 1).toLocaleDateString(locale, { month: 'long' });
};

export const getMonthShort = (month: number, locale = 'en'): string => {
  return new Date(2026, month, 1)
    .toLocaleDateString(locale, { month: 'short' })
    .replace(/\./g, '');
};

export const isToday = (day: number, month: number, year: number): boolean => {
  const today = new Date();
  return today.getDate() === day && today.getMonth() === month && today.getFullYear() === year;
};

export const isWeekend = (day: number, month: number, year: number): boolean => {
  const d = new Date(year, month, day).getDay();
  return d === 0 || d === 6;
};

/** Format a 24h "HH:MM" string as 12-hour "hh:MM AM/PM". */
export const formatTime12h = (time: string): string => {
  const [hStr, mStr] = time.split(':');
  const h24 = parseInt(hStr, 10);
  if (Number.isNaN(h24) || !mStr) return time;
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  const period = h24 < 12 ? 'AM' : 'PM';
  return `${String(h12).padStart(2, '0')}:${mStr} ${period}`;
};
